import { render } from "./CardBody.vue?vue&type=template&id=cbce5cb4&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"

import "./CardBody.vue?vue&type=style&index=0&id=cbce5cb4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbce5cb4"]])

export default __exports__